'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'event-interceptor',
  componentName: 'ElFormItem',
  render: function render() {
    return this.$slots.default[0];
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/@ele/lpd-component/lib/utils/event-interceptor.js
// module id = 307
// module chunks = 0